import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";

import { Loading } from "../SVG";
import WebServiceContext from "../../webService/WebServiceContext";



type MDRTtable={
    compName:string
    total:number
    money:number
    tMoney:number
}

type MDRTProps = {
    currentYear:number
}


const money = (value: number) => {
    var formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
    });
    return formatter.format(value)
}

const MDRT = (props:MDRTProps) => {
    const ws = useContext(WebServiceContext)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [resData, setResData] = useState<MDRTtable[]>([])
    const [allTotal, setAllTotal] = useState<number>(0)
    const [allMoney, setAllMoney] = useState<number>(0)
    const [allTMoney, setAllTMoney] = useState<number>(0)

    useEffect(() => {
        ws.webservice.asyncPerformance("44008_IDA龍獎", props.currentYear).then((res: any) => {
            let _t:MDRTtable[] = []
            let _a1:number = 0
            let _a2:number = 0
            let _a3:number = 0

            //console.log(res)
            if(res && res.length>0){
                res.map((item:any)=>{
                    let _d:MDRTtable={
                        compName: item['公司名稱'].replace("人壽", ""),
                        total: item['發薪件數']?parseInt(item['發薪件數']):0,
                        money: item['發薪業績']?parseInt(item['發薪業績']):0,
                        tMoney: item['發薪保費']?parseInt(item['發薪保費']):0,
                    }
                    _t.push(_d)
                    _a1+=item['發薪件數']?parseInt(item['發薪件數']):0
                    _a2+=item['發薪業績']?parseInt(item['發薪業績']):0
                    _a3+=item['MDRT保費']?parseInt(item['MDRT保費']):0
                })
            }
            setResData(_t)
            setAllTotal(_a1)
            setAllMoney(_a2)
            setAllTMoney(_a3)
            setIsLoading(false)
        })
        return
    }, [props.currentYear])


    if (isLoading) {
        return <Loading />
    } else {
        return (
            <>
            <div className="card-short">
                件數：<span className="value">{allTotal}</span>
                業績：<span className="value">{money(allMoney)}</span>
                保費：<span className="value">{money(allTMoney)}</span>
            </div>
            <div className="MDRT card-content">
                <div className="card-mesg">
                    件數：<span className="value">{allTotal}</span>
                    業績：<span className="value">{money(allMoney)}</span>
                    保費：<span className="value">{money(allTMoney)}</span>
                </div>
                <table id="IDA_table" className="dashboard-table">
                    <thead>
                        <tr>
                            <td></td>
                            <td>發薪件數</td>
                            <td>發薪業績</td>
                            <td>發薪保費</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            resData.map(
                                (item:MDRTtable, index:number)=>
                                <tr key={"row_"+index}>
                                    <td>{item.compName}</td>
                                    <td>{item.total}</td>
                                    <td>{money(item.money)}</td>
                                    <td>{money(item.tMoney)}</td>
                                </tr>
                            )
                        }
                        {/*
                            <tr>                            
                                <td>總計</td>
                                <td>{allTotal}</td>
                                <td>{money(allMoney)}</td>
                            </tr>
                        */}
                    </tbody>
                </table>
            </div>
            </>
        )
    }
}
export default MDRT